import { BaseRecord } from "./BaseRecord";
import { Client } from "./Client";
import { Tenant } from "./Tenant";

export class Zekvo extends BaseRecord<number> {
    public productName!: string;
    public productCode?: string;
    public photoUrl!: string;
    public photoBase64?: string = '';

    public tenantId!: number;
    public tenant: Tenant | null;

    public clientId!: number;
    public client: Client | null;

    constructor() {
        super();
        this.id = 0;
        this.productName = "";
        this.productCode = "";
        this.photoUrl = "";

        this.tenantId = 0;
        this.tenant = new Tenant();

        this.clientId = 0;
        this.client = new Client();
    }
}
